module.exports = __webpack_public_path__ + "img/a7c832e.png";